import { webKnots } from '../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'
import { verticalPartOfWebForJoint, verticalPartOfWebWithLace, verticalPartOfWebWithLaceForJoint } from './parts/verticalParts'

export const crossWebWithLace = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebWithLace(ctx, web2Color, laceColor, stitchColor)
  webKnots(ctx, laceColor, -90, 100) // クロス中央の結び目
  webKnots(ctx, laceColor, -110, 120) // 捕球面上のウェブ結び目
}

export const crossJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, web2Color: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWebWithJoint(ctx, webColor, web2Color, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, web2Color, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebForJoint(ctx, webColor, laceColor, stitchColor)
  // 結び目
  webKnots(ctx, laceColor, -110, 120)
}

export const crossJointWebWithLace = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWebWithJoint(ctx, webColor, web2Color, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, web2Color, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebWithLaceForJoint(ctx, webColor, laceColor, stitchColor)

  webKnots(ctx, laceColor, -90, 100) // クロス中央の結び目
  webKnots(ctx, laceColor, -110, 120) // 捕球面上のウェブ結び目
}
